<template>
  <div
    v-show="tableDisplay === 'route_actions' || tableDisplay === 'actions'"
    class="mt-n16"
  >
    <v-row style="margin-top: -83px">
      <v-spacer></v-spacer>
      <v-col cols="3" class="text-right"> 
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details>
          <template slot="append-outer">
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="12" class="text-right">
        <v-btn
          color="primary"
          dark
          rounded
          small
          class="mx-2"
          @click="createBtn()"
        >
          Create Action
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row> -->

    <v-row class="mb-6 px-3 mt-4" v-show="selected.length > 0">
      <v-app-bar color="grey darken-3" dense dark>
        <v-toolbar-title class="overline"
          >{{ selected.length }} selected</v-toolbar-title
        >
        <v-divider class="mx-4" vertical></v-divider>
        <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="editItem()"
          >Update</v-btn
        >
        <v-btn
          depressed
          class="overline mx-4 custom-hover"
          color="grey darken-3"
          @click="deleteItem()"
          >Delete</v-btn
        >
      </v-app-bar>
    </v-row>
    <v-row>
      <v-col cols="12" class="mb-n7 mt-n2" v-show="showSuccess">
        <v-alert dense text type="success" dismissible>{{ save_type == 'create' ? 'Created new' : 'Updated' }} action</v-alert>
      </v-col>
    </v-row>
    <v-row class="mt-8">
      <v-col cols="12">
        <v-data-table
          :options.sync="options"
          v-model="selected"
          :single-select="false"
          show-select
          :headers="_headers"
          :items="computedActionsList"
          :items-per-page="10"
          class="elevation-2 mt-n6"
          item-key="id"
          :search="search"
          @page-count="pageCount = $event"
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-chip :color="getStatusColor(item.status)" dark></v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <!-- <v-icon small class="mr-2" @click="actionStatus(item)"
              >mdi-pencil</v-icon
            > -->
            <v-btn color="indigo" x-small dark @click="actionStatus(item)">
              Update Template
            </v-btn>
          </template>
        </v-data-table>

        <v-snackbar v-model="snackbar" :timeout="timeout">
          "Must select only one Action to {{ message_type }} details"
          <template v-slot:action="{ attrs }">
            <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-col>
    </v-row>
    <ActionCreateModal
      :dialog="dialog"
      :editItem="editedItem"
      :saveType="save_type"
      @closeDialog="close"
      @showMessage="showMessage"
    />

    <ActionTemplatesDialog
      :accessFrom="tableDisplay"
      :dialog="template_dialog"
      :action="update_template"
      @closeDialog="closeActionStatus"
    />
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import Swal from "sweetalert2";
  import ActionCreateModal from "./ActionCreateModal.vue";
  import LoadingOverlay from "../common/LoadingOverlay.vue";
  import ActionTemplatesDialog from "./ActionTemplatesDialog.vue";

  export default {
    name: "ActionsTable",
    props: {
      // search: String,
      tableDisplay: String,
      isFetching: Boolean,
      dialog: Boolean
    },
    data() {
      return {
        search: "",
        singleSelect: false,
        selected: [],
        // dialog: false,
        headers: [
          {
            text: "Name",
            align: "start",
            sortable: true,
            value: "name",
            show: true,
          },
          { text: "Description", value: "description", show: true },
          { text: "Label", value: "label", show: true },
          { text: "Created", value: "date", show: true },
          {
            text: "Status Template",
            value: "actions",
            sortable: false,
            show:
              this.tableDisplay === "route_actions" ||
              this.tableDisplay === "routes",
            align: "center",
          },
        ],
        editedIndex: -1,
        editedItem: {
          name: "",
          description: "",
          label: "",
          hasDueDate: false,
        },
        defaultItem: {
          name: "",
          description: "",
          label: "",
          hasDueDate: false,
        },
        save_type: "create",
        snackbar: false,
        timeout: 5000,
        template_dialog: false,
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        currentLimit: 5,
        update_template: null,
        showSuccess: false,
        loading: false,
        message_type: "update"
      };
    },
    components: {
      ActionCreateModal,
      ActionTemplatesDialog,
      LoadingOverlay
    },
    methods: {
      ...mapActions(["fetchActions", "deleteAction"]),
      getStatusColor(status) {
        if (status === true) return "green";
        else return "red";
      },
      showMessage (e) {
        this.showSuccess = e;
      },
      editItem() {
        if (this.selected.length > 1) {
          this.snackbar = true;
          this.message_type = "update"
        } else {
          this.editedIndex = this.allActions.indexOf();
          this.editedItem = Object.assign({});
          this.save_type = "update";
          // this.dialog = true;
          this.$emit("openDialog", true)
          this.editedItem = this.selected[0];
        }
      },
      close() {
        this.$emit("closeDialog", false)
        // this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      createBtn() {
        this.dialog = true;
        this.save_type = "create";
      },
      deleteItem() {
        if(this.selected.length > 1) {
          this.snackbar = true
          this.message_type = "delete";
        } else {
          Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        }).then((result) => {
          let selectedItems = [];
          for (let i = 0; i < this.selected.length; i++) {
            selectedItems.push(this.selected[i].id);
          }
          if (result.isConfirmed) {
            this.loading = true;
            this.deleteAction(selectedItems).then(() => {
              this.loading = false;
              this.selected = []
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              // this.fetchActions();
            });
          }
        });
        }
      },
      actionStatus(action) {
        this.update_template = action;
        this.template_dialog = true;
      },
      closeActionStatus() {
		this.update_template = null;
        this.template_dialog = false;
      },
    },
    computed: {
      ...mapGetters(["allActions", "totalActionCount"]),
      computedActionsList() {
        return this.allActions;
      },
      _headers() {
        return this.headers.filter((x) => x.show);
      },
    },
    watch: {
      options() {
        const { page, itemsPerPage } = this.options;
        const actionsLength = this.allActions.length;
        const totalCount = this.totalActionCount;
        let limitChangeStatus = false;

        // if (this.currentLimit != itemsPerPage) {
        //   limitChangeStatus = true;
        //   this.currentLimit = this.options.itemsPerPage;
        // }

        if (!totalCount) return;

        if (itemsPerPage * page > actionsLength) {
          if (actionsLength < totalCount) {
            this.fetchActions({
              bypass: false,
              page,
              limit: itemsPerPage,
              limitChangeStatus,
            });
          }
        }
      },
    },
  };
</script>

<style></style>
